import IconFont from "@/components/icon";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import solarLunar from "solarlunar";
import "./index.less";
import { Scope } from "@/api/calendar";
import { debounce } from "lodash";

export interface ScheduleByUser {
  scheduleId: string;
  title: string;
  beginTime: number;
  endTime: number;
  color: string;
  userId: string;
  userName: string;
  desc: string;
}
export interface ScheduleByDateAndUsersProps {
  userId: string;
  userName: string;
  calendarScope: number;
  schedules: ScheduleByUser[];
}

function userScheduleViewHeader ({ list }: { list: ScheduleByDateAndUsersProps[] }) {
  const items = list.map((l, index) => {
    return (
      <div key={index} className="busy-idle-header-item">
        <div className="busy-idle-title">
          <label>{l.userName}</label>
          {l.calendarScope === Scope.Private && <IconFont type="iconic_app_im_secretchat_facet" />}
        </div>
      </div>
    );
  });
  return (
    <div className="busy-idle-header">
      <div className="busy-idle-header-space-cell">参与人</div>
      {items}
    </div>
  );
}

export const UserScheduleViewHeader = React.memo(userScheduleViewHeader);

export function busyIdleViewHeader({
  t,
  time,
  today,
  handleBusyIdleTimeChange,
  children
}: {
  t: any;
  time: dayjs.Dayjs;
  today: () => void;
  handleBusyIdleTimeChange: (add: boolean) => void;
  children: any;
}) {
  const year = time.year();
  let month = time.month() || 0;
  const date = time.date();
  const lunar = solarLunar.solar2lunar(year, month + 1, date);

  return (
    <div className="busyidle-view-header">
      <div className="left-comp">
        <div
          className={`app-region-none today ${dayjs().isSame(time, "date") ? "" : "notoday"}`}
          onClick={() => {
            if (dayjs().isSame(time, "date")) return;
            today();
          }}
        >
          {t("today")}
        </div>
        <div className="change-date-wrapper app-region-none">
          <IconFont
            type="iconwin_left"
            onClick={debounce(() => handleBusyIdleTimeChange(false), 200)}
          />
          <IconFont
            type="iconwin_right"
            onClick={debounce(() => handleBusyIdleTimeChange(true), 200)}
          />
        </div>
        <div className="time-wrapper">
          <p className="time">
            {`${year}${t("year")}${month + 1}${t("month")}${lunar.cDay}${t("day")} ${t(
              `week_${time.day()}`
            )}`}
          </p>
        </div>
      </div>
      <div className="right-comp">{children}</div>
    </div>
  );
}

export const BusyIdleViewHeader = React.memo(busyIdleViewHeader);
